import { types } from "../types/types";

let cart = []
if(JSON.parse( localStorage.getItem('cart') )){
    cart = JSON.parse( localStorage.getItem('cart') )
}

const initialState = {
    checking: true,
    // uid: null,
    // name:null
    cart
}


export const authReducer = ( state = initialState, action ) =>{
  
    
    switch ( action.type ) {
        case types.authLogin:
            return {
                ...state,
                ...action.payload,
                checking: false
            }
        
        case types.authChekingFinish:
            return {
                ...state,
                checking: false
            }
        case types.authLogOut:
            return {
                checking: false
            }

        case types.authCartAddNew:
            return {
                ...state,
                cart: [...state.cart, {...action.payload}]
            }

        case types.authCartDeleted:
            return {
                ...state,
                cart: [...state.cart.filter(
                    product => (product.id !== action.payload.id)
                ) ]

            }
        case types.authCartClean:
            return{
                ...state,
                cart:[]
            }    
            


        default:
           return state;
    }

};